export function versionedVercelProjectName(base: string, attempt: number): string {
  if (attempt <= 1) return base
  const suffix = `-v${attempt}`
  return `${base.slice(0, 100 - suffix.length)}${suffix}`
}
